import { render, staticRenderFns } from "./EquipDetail.vue?vue&type=template&id=11487441&scoped=true"
import script from "./EquipDetail.vue?vue&type=script&lang=js"
export * from "./EquipDetail.vue?vue&type=script&lang=js"
import style0 from "./EquipDetail.vue?vue&type=style&index=0&id=11487441&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11487441",
  null
  
)

export default component.exports